import checkCheckboxValue from './checkCheckboxValue';
import checkRadioValue from './checkRadioValue';

const conditionalLogicOperators = {
  is: (fieldValue: FormDataEntryValue, conditionalValue: string) => {
    return (
      fieldValue === conditionalValue ||
      checkRadioValue(String(fieldValue), conditionalValue) ||
      checkCheckboxValue(String(fieldValue), conditionalValue)
    );
  },
  isnot: (fieldValue: FormDataEntryValue, conditionalValue: string) => {
    return !(
      fieldValue === conditionalValue ||
      checkRadioValue(String(fieldValue), conditionalValue) ||
      checkCheckboxValue(String(fieldValue), conditionalValue)
    );
  },
  '>': (fieldValue: FormDataEntryValue, conditionalValue: string) => {
    const numFieldValue = Number(fieldValue);
    const numConditionalValue = Number(conditionalValue);
    // проверяем кэйс, когда нужно сравивать именно числа
    if (!isNaN(numFieldValue) && !isNaN(numConditionalValue)) {
      return numFieldValue > numConditionalValue;
    }
    // проверяем кэйс, когда нужно сравивать длину строки с числом
    if (isNaN(numFieldValue) && !isNaN(numConditionalValue)) {
      return String(fieldValue).length > numConditionalValue;
    }
    // проверяем кэйс, когда нужно сравивать длину обеих строк
    return String(fieldValue).length > String(conditionalValue).length;
  },
  '<': (fieldValue: FormDataEntryValue, conditionalValue: string) => {
    const numFieldValue = Number(fieldValue);
    const numConditionalValue = Number(conditionalValue);
    // проверяем кэйс, когда нужно сравивать именно числа
    if (!isNaN(numFieldValue) && !isNaN(numConditionalValue)) {
      return numFieldValue < numConditionalValue;
    }
    // проверяем кэйс, когда нужно сравивать длину строки с числом
    if (isNaN(numFieldValue) && !isNaN(numConditionalValue)) {
      return String(fieldValue).length < numConditionalValue;
    }
    // проверяем кэйс, когда нужно сравивать длину обеих строк
    return String(fieldValue).length < String(conditionalValue).length;
  },
  contains: (fieldValue: FormDataEntryValue, conditionalValue: string) => {
    return String(fieldValue).includes(conditionalValue);
  },
};

type ConditionalLogicOperator = keyof typeof conditionalLogicOperators;

export function checkRule(rule: any, formValuesById: any) {
  const { fieldId, value, operator } = rule;
  const fieldValue = formValuesById[fieldId];

  // если значение поля undefined, сразу возвращаем false
  // оператор isnot без значения неправльно работает, например, у нас undefined, а оператор isnot, проверяет что значение не равно "Russia"
  // undefined !== "Russia" => true, а нам нужно false
  if (fieldValue === undefined) {
    return false;
  }

  const handler =
    operator in conditionalLogicOperators
      ? conditionalLogicOperators[operator as ConditionalLogicOperator]
      : conditionalLogicOperators.is;

  return handler(fieldValue, value);
}

export default checkRule;
